//src/api/material/materialApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const createMaterial = async (formData) => {
    return await axios.post(`${API_URL}/material/create`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export  const  getMaterial =async (user_id,project_id)=>{
    return await axios.get(`${API_URL}/material/list`,{params:{user_id,project_id}});
};


export const deleteMaterial = async(material_id)=>{
    return await axios.delete(`${API_URL}/material/delete/${material_id}`,{
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
};

export const assignMaterialToProject = async (formData) => {
    const response = await axios.post(`${API_URL}/material/assign-to-project`, formData);
    return response;
  };